import { Outlet } from 'react-router';

import { SiteFooter } from './components/site-footer';

// The project's footer values (gabriel-mille/sensa-paved-road#461). The contact is the EI's
// professional address until the project has its own; the legal notice is the EI's single page
// (AgDR-0277); the privacy notice is the app's own page, to write before going public.
const CONTACT_EMAIL = 'contact@u2661.net';
const LEGAL_NOTICE_URL = 'https://u2661.net/mentions-legales/';
const PRIVACY_URL = '/privacy';

export function App() {
  return (
    // A column at least as tall as the window whose main grows: the footer meets the bottom of
    // the window on a short page and follows the content on a long one.
    <div className="flex min-h-dvh flex-col bg-white text-slate-900 antialiased dark:bg-slate-950 dark:text-slate-100">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:rounded focus:bg-brand-700 focus:px-3 focus:py-2 focus:text-white"
      >
        Skip to main content
      </a>
      <main id="main" tabIndex={-1} className="flex-1">
        <Outlet />
      </main>
      <SiteFooter
        contactEmail={CONTACT_EMAIL}
        legalNoticeUrl={LEGAL_NOTICE_URL}
        privacyUrl={PRIVACY_URL}
      />
    </div>
  );
}
